import type { CBlogTranslations } from "./pl";

export const de: CBlogTranslations = {
  emptyData: "Keine Daten zum Anzeigen.",
  emptyList: "Keine Beiträge zum Anzeigen.",
  readMore: "Mehr lesen ->",
  backToList: "Zurück zur Liste",
  paginationAria: "Seitennavigation",
  byAuthor: (name) => `Autor: ${name}`,
  /** `formatDate("2026-05-13")` -> "13. Mai 2026". */
  formatDate: (iso) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!m) return iso;
    const months = [
      "Januar", "Februar", "März", "April", "Mai", "Juni",
      "Juli", "August", "September", "Oktober", "November", "Dezember",
    ];
    const month = parseInt(m[2], 10) - 1;
    if (month < 0 || month > 11) return iso;
    return `${parseInt(m[3], 10)}. ${months[month]} ${m[1]}`;
  },
  paginationLabel: (page, totalPages) => `Seite ${page} von ${totalPages}`,
  paginationHint: "Die Paginierung wird in der nächsten Iteration angeschlossen",
  readingMinutes: (n) => `${n} Min.`,
};
